import React from "react";
import { Phone } from "lucide-react";

export default function FloatingCall() {
  return (
    <a
      href="tel:8169272803"
      data-testid="floating-call-btn"
      aria-label="Call Customade"
      className="fixed bottom-5 left-5 md:bottom-6 md:left-6 z-40 nb-border-4 nb-shadow bg-[#FF0055] text-white rounded-full w-14 h-14 flex items-center justify-center hover:-translate-x-1 hover:-translate-y-1 transition-transform"
    >
      <Phone size={22} strokeWidth={3} />
    </a>
  );
}
